import PropTypes from "prop-types";

const Email = ({ email, subject = "", body = "", style, children }) => {
  let params = subject || body ? "?" : "";
  if (subject) params += `subject=${encodeURIComponent(subject)}`;
  if (body) params += `${subject ? "&" : ""}body=${encodeURIComponent(body)}`;

  return (
    <a href={`mailto:${email}${params}`} style={style}>
      {children}
    </a>
  );
};

Email.propTypes = {
  email: PropTypes.string.isRequired,
  subject: PropTypes.string,
  body: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node.isRequired,
};

export default Email;
